import React, { useState } from "react";
import "./Navbar.css";
import {
  Button,
  Menu,
  MenuItem,
  Fade,
  Link,
  Typography,
  AccordionDetails,
  IconButton,
  Tooltip,
} from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import { renderToString } from "react-dom/server";
import { isMobile as isMobileDevice } from "react-device-detect";
import home from "../../../assests/homeScreen/home.svg";
import hamburgerIcon from "../../../assests/header/hamburger.svg";
import DynamicBreadcrumb from "../../../customTheme/breadcrumbs/breadcrumbs";
// Accordians for Mobile Menus
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { languageOptions } from "./Constant";
import { DEFAULT_NAVBAR_CATEGORY_COLOR, NAVBAR_CATEGORY_COLORS } from "./categoryColors";
import { useSelector } from "react-redux";
import globalicon from "../../../assests/homeScreen/Globe icon copy.png";
import explogo from "../../../assests/homeScreen/Lgo.jpg.jpeg"
// import LanguageIcon from '@mui/icons-material/Language';

// Custom hook to detect mobile view (combines user agent detection with viewport width)
const useMobileView = () => {
  const [isMobileViewport, setIsMobileViewport] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth <= 520 : false
  );

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobileViewport(window.innerWidth <= 520);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Return true if either user agent detection OR viewport width indicates mobile
  return isMobileDevice || isMobileViewport;
};

const Navbar = (props) => {
  const [showBoardMenu, setShowBoardMenu] = useState(false);
  const [activeClass, setActiveClass] = useState("ALL");
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const isMobile = useMobileView();
  const location = useLocation();
  const pathName = location.pathname.split("/");
  const classMenuRef = React.useRef(null);
  React.useLayoutEffect(() => {
    const menu = classMenuRef.current;
    if (!menu) return undefined;

    const alignLastClass = () => {
      const currentModule = location.pathname.toLowerCase().split("/")[2] || "";
      menu.scrollLeft = currentModule === "academic"
        ? Math.max(0, menu.scrollWidth - menu.clientWidth)
        : 0;
    };

    alignLastClass();
    window.addEventListener("resize", alignLastClass);
    return () => window.removeEventListener("resize", alignLastClass);
  }, [props.data?.length, location.pathname]);
  const [anchorEl, setAnchorEl] = React.useState(
    new Array(props.data.length).fill(null)
  ); // dynamically add array according to length of data
  const [expanded, setExpanded] = React.useState(false);
  const { appType } = useSelector((state) => state.login);
  // Mobile Menu Main Accordion
  React.useEffect(() => {
    setActiveClass("ALL");
  }, [location.pathname]);

  React.useEffect(() => {
    const syncAcademicSelection = (event) => {
      const selectedClass = event.detail?.selectedClass;
      setActiveClass(selectedClass == null ? "ALL" : String(selectedClass));
    };
    window.addEventListener("academic-selection-changed", syncAcademicSelection);
    return () => {
      window.removeEventListener("academic-selection-changed", syncAcademicSelection);
    };
  }, []);



  // Function handle on click event for navbar menu clicked
  // handle anchoring of overlay menus with the navbar menu btn
  // @param (event, index of menu clicked)
  const handleClick = (event, index) => {
    const newAnchorEl = [...anchorEl];
    newAnchorEl[index] = event.target;
    setAnchorEl(newAnchorEl);
  };
  // Function handle on close events for closing or de anchoring
  // menus overlays
  // @param (index of menu to be close or mounted menu)
  const handleClose = (index) => {
    const newAnchorEl = [...anchorEl];
    newAnchorEl[index] = null;
    setAnchorEl(newAnchorEl);
  };
  // Function handle selected items of menus
  // @param (index of parent in navbar, index of parent child selected)
  const handleItemsClick = (navIndex, childIndex, title) => {
    props.handleSelectedNavbar(navIndex); // Like Grade, class, etc
    props.handleSelectedChild(childIndex); // Like Grade 1 and all
    // if (title === "Chart Maker") {
    //   handleClose(navIndex);
    // } else {
    props.handleSetSelectedMenu(0);
    props.handleSetMenu();
    props.handleImageFetch("navbar", navIndex, childIndex);
    handleClose(navIndex);
    // }
  };
  const getCurrentPath = () => {
    let pathName = location.pathname.split("/");
    return pathName;
  };
  
  // Get the correct base path for navigation
  // If current path is a special page (privacy, result, terms, etc), default to 'academic'
  const getNavigationBasePath = () => {
    const currentPath = getCurrentPath()[2];
    const validBasePaths = ['academic', 'early-career', 'edutainment', 'print-rich', 'maker', 'info-hub', 'sections'];
    if (validBasePaths.includes(currentPath)) {
      return currentPath;
    }
    return 'academic';  // Default to academic for special pages
  };
  const removeHTML = (str) => {
    str = renderToString(str.title)
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(" ", "-")
      .toLowerCase();
    return str;
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [anchorLanguageEl, setAnchorLanguageEl] = React.useState(null);
  const [languagePage, setLanguagePage] = React.useState(0);
  const opened = Boolean(anchorLanguageEl);
  const handleLanguageClick = (event) => {
    setLanguagePage(0);
    setAnchorLanguageEl(event.currentTarget);
  };
  const handleLanguageClose = () => {
    setAnchorLanguageEl(null);
  };
 const navLanguageOptions = () => {
  const start = languagePage * 10;
  const visibleLanguages = languageOptions.slice(start, start + 10);

  return (
    <div className="navLanguageOptions">

      {visibleLanguages.map((key, index) => (
        <MenuItem
          key={`nav-lang-${start + index}`}
          className="languageMenuItem"
        >
          <Link
            to={key.url}
            className="navLanguageOptionsLink"
          >
            <Typography
            sx={{
                color: "#2c48b5",
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 500,
                fontSize: "16px",
                width: "100%",
                textAlign: "left"
              }}
            >
              {key.name.toUpperCase()}
            </Typography>
          </Link>
        </MenuItem>
      ))}

      {/* DOWN ARROW */}
  {(languagePage > 0 || start + 10 < languageOptions.length) && (
  <button
    type="button"
    className="languageMenuPager"
    aria-label={languagePage > 0 ? "Previous languages" : "Next languages"}
    onClick={(e) => {
      e.stopPropagation();

      if (languagePage > 0) {
        setLanguagePage(prev => prev - 1);
      } else {
        setLanguagePage(prev => prev + 1);
      }
    }}
  >
    <span aria-hidden="true">{languagePage > 0 ? "▲" : "▼"}</span>
  </button>
)}

    </div>
  );
};
const currentModule = location.pathname.split("/")[2];

const navbarBgColor =
  NAVBAR_CATEGORY_COLORS[currentModule] || DEFAULT_NAVBAR_CATEGORY_COLOR;
  return (
    <div
      className="navbarMenuDiv"  style={{
    backgroundColor: navbarBgColor
  }}
    // style={
    //   isMobile
    //     ? { maxHeight: "calc(100vh - 230px)", overflowY: "auto" }
    //     : null
    // }
    >
      <div className={isMobile ? "mobGutter" : "navbarHomeGutter"}>
     {isMobile ? null : (
  <div className="languageMainContainer">

   <IconButton
  className="languageButtonIcon"
  id="avatarBtn"
  aria-controls={opened ? "basic-menu" : undefined}
  aria-haspopup="true"
  aria-expanded={opened ? "true" : undefined}
  onClick={handleLanguageClick}
  style={{
    width: "160px",
    height: "35px",
    padding: 0,
    margin: 0
  }}
>
      <Typography
        className="languageButton"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          padding: 0,
          margin: 0,
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 500,
          fontSize: "15px",
          color: "#2c48b5"
        }}
      >
        <img
          src={globalicon}
          alt="Language"
          style={{
            width: "20px",
            height: "20px",
            objectFit: "contain"
          }}
        />

        Languages
      </Typography>
    </IconButton>

 <Menu
  disableScrollLock
  classes={{
    paper: "languageMenu"
  }}
  anchorEl={anchorLanguageEl}
  transformOrigin={{
    horizontal: "left",
    vertical: "top"
  }}
  anchorOrigin={{
    horizontal: "left",
    vertical: "bottom"
  }}
  open={opened}
  onClose={handleLanguageClose}
  MenuListProps={{
    "aria-labelledby": "avatarBtn"
  }}
  sx={{
  ".MuiMenu-paper": {
  background: "#ffffff",
  marginTop: "4px",
  marginLeft: "0px",
  borderTop: "1px solid #e8eefb",
  width: "min(160px, calc(100vw - 24px))",
  minWidth: "min(160px, calc(100vw - 24px))",
  maxHeight: "min(85vh, 600px)",
  fontFamily: "'Poppins', sans-serif",
  boxShadow: "0 14px 40px rgba(13, 36, 92, 0.18)",
  color: "#2c48b5",
  borderRadius: "20px",
  padding: 0,
  overflowX: "hidden",
  overflowY: "auto"
},

    ".MuiMenu-list": {
      padding: 0
    }
  }}
>
  {navLanguageOptions()}
</Menu>

  </div>
)}
      </div>
      {isMobile && props.overlay === undefined ? (
        <div className="mobNavbarMenu">
          <div className="icon" style={{ display: "flex", flex: 1, gap: '10px', alignItems: 'center' }}>
            <Link
              underline="hover"
              color="text.primary"
              href="/"
              aria-current="page"
              style={{display : appType !== "none" ? "none" : "flex"}}
            >
              <img alt="" src={home} style={{ width: '20px',  }} />
            </Link>
            <div 
              onClick={() => props.mobileDrawer(true)} 
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', flex: 1 }}
            >
              {/* <DynamicBreadcrumb color={"pink"} /> */}
              <span style={{color:"#fff",fontWeight:"600",    fontFamily: "Poppins, sans-serif",letterSpacing:"2px"
}}>HOME</span>
            </div>
          </div>
          {appType === "none" ? (
            <div
              onClick={() => props.mobileDrawer(true)}
              className="hamburgerIcon"
              style={{ cursor: 'pointer', padding: '8px' }}
            >
              <img src={hamburgerIcon} alt="Menu" />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div
                onClick={() => props.mobileDrawer(true)}
                className="hamburgerIcon"
                style={{ cursor: 'pointer', padding: '8px' }}
              >
                <img src={hamburgerIcon} alt="Menu" />
              </div>
              <div 
                onClick={() => window.flutter_inappwebview?.callHandler('closeWebView', '*')}
                style={{ cursor: 'pointer', padding: '8px' }}
              >
                <Typography>Back to App</Typography>
              </div>
            </div>
          )}
        </div>
      ) : null}
      {isMobile && props.overlay === undefined ? null :
        <>
          <nav className="navbarenu" style={props?.overlay ? { flex: 1 } : null}>
            {!props?.overlay ? (
           <ul
  className="menus"
  style={
    props.overlay
      ? { flexDirection: "column", alignItems: "flex-start" }
      : {}
  }
>
  {/* LEFT SIDE - Logo Section */}
  {/* <div className="navbarLeftLogo"> */}
    {/* <div className="logoText">myschool<span className="logoMark">™</span></div>
    <div className="logoSubtitle">the soul of education</div> */}
  {/* </div> */}
<div className="navBoardHeading">
  <Typography
    className="boardButton"
    onClick={() => setShowBoardMenu(!showBoardMenu)}
    aria-haspopup="true"
    aria-expanded={showBoardMenu}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "130px",
      height: "33px",
      marginLeft:"46px",
      marginRight:"2px",
      transform: "translateX(-7px)",
      whiteSpace: "nowrap",
      cursor: "pointer",
      fontFamily: "'Poppins', sans-serif",
      fontWeight: 500,
      fontSize: "15px",
      border: "1px solid #fff",
      background: "#fff",
      borderRadius: "50px",
      color: "#ff4fa0",
    }}
  >
    Select Board
  </Typography>
</div>
{showBoardMenu && (
  <div className="boardMenu">

    <div className="boardItem">CBSC</div>
    <div className="boardItem">AP SCERT</div>
    <div className="boardItem">GJ SCERT</div>
    <div className="boardItem">TS SCERT</div>

    <div
      className="boardArrow"
      onClick={() => setShowBoardMenu(false)}
    >
      ▼
    </div>

  </div>
)}
  {/* MIDDLE - Navigation Menus Container to check menu see in screeninzilaizer.css from there check index.jsx*/}
  


<div className="navbarMiddleMenus" ref={classMenuRef}>
  {props.data.map((k, i) => {
    const title = k?.title || "";
    const normalizedTitle = title.toLowerCase();

    const classGroups = [
      {
        match: "foundational",
        name: "Foundational",
        classes: ["KG", "LKG", "UKG", "1", "2"],
      },
      {
        match: "preparatory",
        name: "Preparatory",
        classes: ["3", "4", "5"],
      },
      {
        match: "middle",
        name: "Middle",
        classes: ["6", "7", "8"],
      },
      {
        match: "secondary",
        name: "Secondary",
        classes: ["9", "10", "11", "12"],
      },
    ];

    const group = classGroups.find((item) =>
      normalizedTitle.includes(item.match)
    );

    if (group) {
      return (
        <div
          key={`class-group-${i}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              color: "#fff",
              fontFamily: "Poppins, sans-serif",
              fontSize: "15px",
              fontWeight: 700,
              whiteSpace: "nowrap",
              marginRight: "4px",
            }}
          >
            {group.name}
          </span>

          {group.classes.map((className) => (
            <Button
              key={className}
              className="headerClassButton"
              aria-pressed={activeClass === className}
              onClick={() => {
                setActiveClass(className);
                props.onSelectClass?.(className);

                window.dispatchEvent(
                  new CustomEvent("academic-class-selected", {
                    detail: className,
                  })
                );
              }}
              sx={{
                padding: "0 12px",
                minWidth: "auto",
                height: "38px",
                color: "#fff",
                fontFamily: "Poppins, sans-serif",
                fontSize: "15px",
                fontWeight: 300,
                border:
                  activeClass === className
                    ? "1px solid #fff"
                    : "1px solid transparent",
                borderRadius: "5px",
                backgroundColor: "transparent",
                boxSizing: "border-box",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.08)",
                },
              }}
            >
              {className}
            </Button>
          ))}
        </div>
      );
    }

    const isCategoryAllActive =
      ["academic", "early-career", "edutainment", "print-rich", "maker", "info-hub", "sections"].includes(currentModule) &&
      normalizedTitle === "all" &&
      activeClass === "ALL";

    return (
      <div key={`mid-header-${i}`}>
        <Button
          disabled={normalizedTitle === "more"}
          aria-controls={
            Boolean(anchorEl[i])
              ? `fade-${title}-${i}`
              : undefined
          }
          aria-haspopup="true"
          aria-pressed={normalizedTitle === "all" ? isCategoryAllActive : undefined}
          sx={{
            padding: "0 22px",
            minWidth: "auto",
            height: "38px",
            whiteSpace: "nowrap",
            border: isCategoryAllActive ? "1px solid #fff" : "1px solid transparent",
            borderRadius: "5px",
            backgroundColor: isCategoryAllActive ? "rgba(255,255,255,0.14)" : "transparent",
            boxSizing: "border-box",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.08)",
            },
          }}
          className={[
            Boolean(anchorEl[i]) ? "navbarMenuActive" : null,
            normalizedTitle !== "all" &&
            pathName.includes(
              normalizedTitle.replace(/\s+/g, "-")
            )
              ? "selectedActive"
              : isCategoryAllActive
                ? "selectedActive"
                : null,
          ]
            .filter(Boolean)
            .join(" ")}
          style={{
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            fontSize: "15px",
            height: "38px",
            whiteSpace: "nowrap",
            fontWeight: 300,
          }}
          aria-expanded={
            Boolean(anchorEl[i]) ? "true" : undefined
          }
          onClick={(e) => {
            if (normalizedTitle === "all") {
              setActiveClass("ALL");
              props.onSelectClass?.(null);
              window.dispatchEvent(
                new CustomEvent("academic-class-selected", { detail: null })
              );
              return;
            }
            handleClick(e, i);
          }}
        >
          <span style={{ fontWeight: 300 }}>
            {title}
          </span>
        </Button>
      </div>
    );
  })}
</div>



{/* <div className="logo">
  <img src={explogo} alt="exp_logo"/>
</div>
<br></br>
<div className="joinTutorHubWrapper">
  <button className="joinTutorHubBtn">
    Join Tutor Hub
  </button>
</div> */}
<div className="navbarUtilityControls">
<div className={`logoDropdownWrapper ${profileMenuOpen ? 'profileMenuOpen' : ''}`}>
  <div
    className="logo"
    role="button"
    tabIndex={0}
    aria-expanded={profileMenuOpen}
    onClick={() => setProfileMenuOpen((open) => !open)}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setProfileMenuOpen((open) => !open);
      }
    }}
  >
    <img src={explogo} alt="exp_logo" />
  </div>

  <div className="explogoDropdown" onClick={(event) => event.stopPropagation()}>
    <div className="dropdownItem">LMS</div>
    <div className="dropdownItem activeDropdownItem">ERP</div>
    <div className="dropdownItem">WEB SITE MAKER</div>
    <div className="dropdownItem">WORKSHEET MAKER</div>
    <div className="dropdownItem">STORY BOOK MAKER</div>
    <div className="dropdownItem">CHART MAKER</div>
    <div className="dropdownItem">FLASH CARD MAKER</div>
    <div className="dropdownItem">E BOOK MAKER</div>
    <div className="dropdownItem">STATIONARY MAKER</div>
    <div className="dropdownItem">FONT MAKER</div>

    <div className="dropdownArrow">⌄</div>
  </div>
</div>

<div className="joinTutorHubWrapper">
  <button className="joinTutorHubBtn">
    <span className="joinText">Join</span>
    <span className="tutorHubText">Tutor Hub</span>
  </button>
</div>
 </div>
 
 {/* <div className=""> */}
      
     
      {/* <div className="menu-item">
        <span className="menu-trigger">CORE SUBJECTS</span>
        
       
        <div className="dropdown-card">
          <ul className="dropdown-list">
            <li>Visual work sheets</li>
            <li>Art and Craft lessons</li>
            <li>Cursive writing</li>
            <li>Cut-paste Charts</li>
            <li>Comics teach English</li>
            <li>Pictorial stories</li>
            <li>Life skills</li>
            <li>Subject posters</li>
            <li>Mapping skills</li>
          </ul>
        
          <div className="dropdown-arrow-down">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7 7L13 1" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>

     
      <div className="menu-item">
        <span className="menu-trigger">MAIN CATEGORIES</span>
        
      
        <div className="dropdown-card">
          <ul className="dropdown-list">
            <li>Cut and paste charts</li>
            <li>My first library book</li>
            <li>Knowledge cards</li>
            <li>Print o book</li>
            <li>Classroom project</li>
            <li>Animations</li>
            <li>Interactive Games</li>
            <li>Subject Power points</li>
            <li>Nano pocket books unfold</li>
          </ul>
        
          <div className="dropdown-arrow-down">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7 7L13 1" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
      
      
      <div className="menu-item">
        <span className="menu-trigger">SELECTED MATERIALS</span>
        
    
        <div className="dropdown-card">
          <ul className="dropdown-list">
            <li>Mind map Infographics</li>
            <li>Parent teacher activities</li>
            <li>Teacher Manuals</li>
            <li>Education magazines</li>
            <li>Q/A Bank</li>
            <li>Computer lessons</li>
            <li>Early Career programme</li>
            <li>Class-wise Video lessons</li>
            <li>Chapter wise lesson PPTs</li>
          </ul>
        
          <div className="dropdown-arrow-down">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7 7L13 1" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div> */}

    {/* </div> */}
</ul>
            ) : (
              <ul
                className="menus"
                style={
                  props.overlay
                    ? { flexDirection: "column", alignItems: "flex-start" }
                    : {}
                }
              >
                {props.data.map((k, i) => {
                  return (
                    <Accordion
                      key={`mid-header-${i}`}
                      sx={{
                        width: "100%",
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        color: "white",
                      }}
                      expanded={expanded === `panel${i}`}
                      onChange={handleChange(`panel${i}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
                        aria-controls={`panel${i}bh-content`}
                        id={`panel${i}bh-header`}
                      >
                        <Typography sx={{ flex: 1 }}>{k.title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {k.children
                          .sort((a, b) => a.title < b.title)
                          .map((ck, ci) => (
                            <NavLink
                              key={`mid-header-${i}-${ci}`}
                              style={{ textDecoration: "none" }}
                              exact="true"
                              to={{
                                pathname: (() => {
                                  const parentNormalized = k.title.toLowerCase().replace(/[\s-]/g, '');
                                  const childPath = removeHTML(ck);
                                  const currentBasePath = getNavigationBasePath();
                                  
                                  // CLASS and GRADE should always go to /views/academic
                                  if (parentNormalized === 'class' || parentNormalized === 'grade') {
                                    const basePath = `/views/academic/${k.title.toLowerCase().replace(' ', '-')}`;
                                    const childNormalized = childPath.toLowerCase().replace(/[\s-]/g, '');
                                    if (parentNormalized === childNormalized) {
                                      return basePath;
                                    }
                                    return `${basePath}/${childPath}`;
                                  }
                                  
                                  // MAKERS should go to /views/maker/makers route
                                  if (parentNormalized === 'makers') {
                                    return `/views/maker/makers/${childPath}`;
                                  }
                                  
                                  // Handle Image Bank navigation based on current section
                                  if (parentNormalized === 'imagebank') {
                                    if (currentBasePath === 'academic') {
                                      return `/views/academic/imagebank/${childPath}`;
                                    }
                                    return `/views/sections/image-bank/${childPath}`;
                                  }
                                  
                                  const basePath = `/views/${currentBasePath}/${k.title.toLowerCase().replace(' ', '-')}`;
                                  const childNormalized = childPath.toLowerCase().replace(/[\s-]/g, '');
                                  if (parentNormalized === childNormalized) {
                                    return basePath;
                                  }
                                  return `${basePath}/${childPath}`;
                                })(),
                                search: `?main=${i}&mu=${ci}`,
                              }}
                            >
                              <MenuItem
                                style={{ paddingLeft: 25, paddingRight: 25 }}
                                onClick={() => handleItemsClick(i, ci, ck.title)}
                              >
                                {ck.title}
                              </MenuItem>
                            </NavLink>
                          ))}
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </ul>
            )}
          </nav>
        </>
      }
      <div className={isMobile ? "mobGutter" : "homeGutter"} />
    </div>
  );
};
export default Navbar;
